<template>
  <nav class="main-nav">
    <router-link to="/develops" data-role="Developer" aria-label="Developer"></router-link>
    <router-link to="/designs" data-role="Designer" aria-label="Designer"></router-link>

    <template v-if="$route.name !== 'home'">
      <router-link to="/" class="home" aria-label="Home">
        <Logo />
      </router-link>
    </template>

    <router-link to="/draws" data-role="Illustrator" aria-label="Illustrator"></router-link>
    <router-link to="/authors" data-role="Author" aria-label="Author"></router-link>
  </nav>
</template>

<script>
import Logo from "@/components/Logo.vue";

export default {
  name: "NavBar",
  components: {
    Logo
  }
};
</script>

<style scoped lang="scss">
nav {
  text-align: center;

  a {
    text-decoration: none;
  }
}

a {
  background: white url("../assets/nav-icons.svg") 0 0 / auto 50px no-repeat;
  //border: 1px solid #333;
  border-radius: 50%;
  display: inline-block;
  height: 50px;
  line-height: 50px;
  margin: 0 10px;
  position: relative;
  text-align: center;
  transition: transform 0.3s ease-out, background 0.3s;
  width: 50px;
  vertical-align: middle;

  &:after {
    color: black;
    content: attr(data-role);
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -15px);
    transition: transform 0.3s, opacity 0.3s;
  }

  &:not(.router-link-exact-active):hover {
    transform: scale(1.25) translateY(10px);

    &:after {
      opacity: 1;
      transform: translate(-50%);
    }
  }

  svg {
    display: inline-block;
    max-height: 100%;
    max-width: 100%;
  }

  &.home {
    border-radius: none;
    border: 0 none;
  }

  &[href="/develops"] {
    background-position: -50px 0;
  }

  &[href="/designs"] {
    background-position: -100px 0;
  }

  &[href="/draws"] {
    background-position: -150px 0;
  }

  &[href="/authors"] {
    background-position: -200px 0;
  }

  &.router-link-exact-active {
    background-blend-mode: overlay;
    border-color: transparent;
    transform: translateY(60%);

    &[href="/develops"] {
      background-color: #99cc66;
    }
    &[href="/designs"] {
      background-color: #333333;
    }
    &[href="/draws"] {
      background-color: #18a4b9;
    }
    &[href="/authors"] {
      background-color: #ffa500;
    }
  }
}

.designs a:after {
  color: white;
}
</style>
